import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ChartOptions } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { SubscriptionService } from '../services/subscription.service';
// Extend Date prototype for week number
declare global {
  interface Date {
    getWeek(): number;
  }
}
Date.prototype.getWeek = function(): number {
  const d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
};
@Component({
  selector: 'app-subscription-info',
  templateUrl: './subscription-info.component.html',
  styleUrls: ['./subscription-info.component.scss'],
})
export class SubscriptionInfoComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;






  userInfo: any = {
    subscription: 'Premium Plan',
    expiry: '2025-12-31',
    amount: 499,
    discount: 50,
  };

  showCustomRange = false;
  dateRange = { from: '', to: '' };
  selectedRange: string = 'hourly';
  selectedFrequency: string = 'hourly';
  showDatePicker = false;
  selectedDate: string = '';
  activeField: 'from' | 'to' = 'from';

  dataConsumption: any = {
    used: 0,
    quota: 5000,
  };

// Bora Bora themed chart options
lineChartOptions: ChartOptions<'line'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'top',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 20,
        font: {
          family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          size: 12,
          weight: '600'
        },
        color: '#64748B'
      }
    },
    tooltip: {
      backgroundColor: 'rgba(30, 41, 59, 0.9)',
      titleColor: '#FFFFFF',
      bodyColor: '#FFFFFF',
      borderColor: '#06B6D4',
      borderWidth: 1,
      padding: 12,
      cornerRadius: 8,
      displayColors: true,
      callbacks: {
        label: (context) => ` ${context.parsed.y} MB`
      }
    }
  },
  scales: {
    x: {
      grid: {
        color: '#E0F2FE',
        display: true
      },
      border: {
        display: false
      },
      ticks: {
        color: '#64748B',
        font: {
          size: 10,
          weight: '500'
        },
        maxRotation: 45,
        minRotation: 45
      }
    },
    y: {
      grid: {
        color: '#E0F2FE',
        display: true
      },
      border: {
        display: false
      },
      ticks: {
        color: '#64748B',
        font: {
          size: 11,
          weight: '500'
        },
        callback: (value) => `${value} MB`
      },
      beginAtZero: true
    }
  },
  interaction: {
    intersect: false,
    mode: 'index'
  }
};
  // Bora Bora themed chart data
  lineChartData: any = {
    labels: [],
    datasets: [{
      label: 'Data Used (MB)',
      data: [],
      borderColor: '#06B6D4',
      backgroundColor: (context: any) => {
        const ctx = context.chart.ctx;
        const gradient = ctx.createLinearGradient(0, 0, 0, 250);
        gradient.addColorStop(0, 'rgba(6, 182, 212, 0.3)');
        gradient.addColorStop(1, 'rgba(6, 182, 212, 0.01)');
        return gradient;
      },
      pointBackgroundColor: '#EC4899',
      pointBorderColor: '#FFFFFF',
      pointBorderWidth: 2,
      pointRadius: 5,
      pointHoverRadius: 7,
      pointHoverBackgroundColor: '#EC4899',
      pointHoverBorderColor: '#FFFFFF',
      pointHoverBorderWidth: 3,
      tension: 0.4,
      fill: true,
      borderWidth: 3
    }]
  };

  constructor(private subscriptionService: SubscriptionService) {}

  ngOnInit() {
    this.initializeDates();
    this.loadInitialData();
  }

  private initializeDates() {
    const now = new Date();
    const midnight = new Date();
    midnight.setHours(0, 0, 0, 0);

    this.dateRange.from = midnight.toISOString().slice(0, 16);
    this.dateRange.to = now.toISOString().slice(0, 16);
    this.selectedDate = this.getTodayDate();
  }

  private loadInitialData() {
    this.setChartData(this.selectedRange);

    this.subscriptionService.fetchUserInfo().subscribe({
      next: (res) => {
        this.userInfo = res;
      },
      error: (err) => console.error('Error fetching user info:', err)
    });

    const data = {
      frm: this.dateRange.from,
      to: this.dateRange.to,
      period: 'H'
    };

    this.subscriptionService.fetchDataConsumption(data).subscribe({
      next: (res) => {
        this.dataConsumption = res;
      },
      error: (err) => console.error('Error fetching data consumption:', err)
    });
  }

  onFrequencyChange() {
    this.selectedRange = this.selectedFrequency;
    this.setChartData(this.selectedRange);
  }

  openDatePicker(field: 'from' | 'to') {
    this.activeField = field;
    this.selectedDate = this.dateRange[field] || new Date().toISOString();
    this.showDatePicker = true;
  }

  getTodayDate(): string {
    return new Date().toISOString().slice(0, 16);
  }

  onDateChange(event: any) {
    this.selectedDate = event.detail.value;
  }

  closeDatePicker() {
    if (this.activeField) {
      this.dateRange[this.activeField] = this.selectedDate;
    }
    this.showDatePicker = false;
  }

  onDateDismiss() {
    this.showDatePicker = false;
  }

  onToggleChange() {
    if (!this.showCustomRange) {
      this.setChartData('hourly');
    }
  }

  applyCustomRange() {
    const fromDate = new Date(this.dateRange.from);
    const toDate = new Date(this.dateRange.to);

    if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime()) || fromDate > toDate) {
      console.error('Invalid date range');
      return;
    }

    // Fetch real data from API
    const periodMap: { [key: string]: string } = {
      hourly: 'H',
      daily: 'D',
      weekly: 'W',
      monthly: 'M'
    };

    const data = {
      frm: this.dateRange.from,
      to: this.dateRange.to,
      period: periodMap[this.selectedFrequency] || 'H'
    };

    this.subscriptionService.fetchDataConsumption(data).subscribe({
      next: (res: any) => {
        // Update chart with API response
        if (res.labels && res.data) {
          this.lineChartData.labels = res.labels;
          this.lineChartData.datasets[0].data = res.data;
        }
        
        if (res.used !== undefined && res.quota !== undefined) {
          this.dataConsumption = {
            used: res.used,
            quota: res.quota
          };
        }

        this.updateChart();
      },
      error: (err) => {
        console.error('Error fetching data:', err);
        // Fallback to mock data
        this.generateMockData(fromDate, toDate);
      }
    });
  }

  private generateMockData(fromDate: Date, toDate: Date) {
    const labels: string[] = [];
    const data: number[] = [];
    const current = new Date(fromDate);

    while (current <= toDate) {
      labels.push(this.formatDateLabel(current, this.selectedFrequency));
      data.push(Math.floor(Math.random() * 100) + 20);

      switch (this.selectedFrequency) {
        case 'hourly':
          current.setHours(current.getHours() + 1);
          break;
        case 'daily':
          current.setDate(current.getDate() + 1);
          break;
        case 'weekly':
          current.setDate(current.getDate() + 7);
          break;
        case 'monthly':
          current.setMonth(current.getMonth() + 1);
          break;
      }
    }

    this.lineChartData.labels = labels;
    this.lineChartData.datasets[0].data = data;

    this.dataConsumption = {
      used: parseFloat(data.reduce((a, b) => a + b, 0).toFixed(2)),
      quota: this.calculateQuota(this.selectedFrequency)
    };

    this.updateChart();
  }

  private formatDateLabel(date: Date, frequency: string): string {
    switch (frequency) {
      case 'hourly':
        return `${date.toLocaleString('default', { month: 'short' })} ${date.getDate()}, ${date.getHours() % 12 || 12}:00 ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
      case 'daily':
        return `${date.getMonth() + 1}/${date.getDate()}`;
      case 'weekly':
        return `Week ${date.getWeek()}`;
      case 'monthly':
        return date.toLocaleString('default', { month: 'short', year: 'numeric' });
      default:
        return date.toLocaleDateString();
    }
  }

  setChartData(range: string) {
    const fromDate = new Date(this.dateRange.from);
    const toDate = new Date(this.dateRange.to);
    
    const labels: string[] = [];
    const data: number[] = [];

    const diffMs = Math.abs(toDate.getTime() - fromDate.getTime());
    
    let steps: number;
    switch (range) {
      case 'hourly':
        steps = Math.ceil(diffMs / 3600000);
        break;
      case 'daily':
        steps = Math.ceil(diffMs / 86400000);
        break;
      case 'weekly':
        steps = 4;
        break;
      case 'monthly':
        steps = 12;
        break;
      default:
        steps = 24;
    }

    // Limit steps to prevent performance issues
    steps = Math.min(steps, 50);

    for (let i = 0; i < steps; i++) {
      const value = Math.floor(Math.random() * 100) + 20;
      let currentDate: Date;

      switch (range) {
        case 'hourly':
          currentDate = new Date(fromDate.getTime() + i * 3600000);
          labels.push(`${currentDate.toLocaleString('default', { month: 'short' })} ${currentDate.getDate()}, ${currentDate.getHours() % 12 || 12}:00 ${currentDate.getHours() >= 12 ? 'PM' : 'AM'}`);
          break;
        case 'daily':
          currentDate = new Date(fromDate.getTime() + i * 86400000);
          labels.push(`${currentDate.getMonth() + 1}/${currentDate.getDate()}`);
          break;
        case 'weekly':
          labels.push(`Week ${i + 1}`);
          break;
        case 'monthly':
          currentDate = new Date(toDate.getFullYear(), toDate.getMonth() - i, 1);
          labels.push(currentDate.toLocaleString('default', { month: 'short' }));
          break;
      }

      data.push(value);
    }

    this.lineChartData.labels = labels;
    this.lineChartData.datasets[0].data = data;

    const used = data.reduce((sum, val) => sum + val, 0);
    const quota = this.calculateQuota(range);

    this.dataConsumption = {
      used: parseFloat(used.toFixed(2)),
      quota: quota
    };

    this.updateChart();
  }

  calculateQuota(range: string): number {
    const quotaMap: { [key: string]: number } = {
      hourly: 500,
      daily: 1000,
      weekly: 5000,
      monthly: 20000,
      yearly: 100000
    };
    return quotaMap[range] || 1000;
  }

  private updateChart() {
    if (this.chart) {
      this.chart.update();
    }
  }
}
